import React from 'react';
import { Typography, Grid, TextField, Box, Slider } from '@mui/material';

const SpeciesPicker = ({ standSpecies, setStandSpecies }) => {
    const speciesOptions = ['Tall', 'Gran', 'Bjork'];

    const getPercentage = (species) => {
        const found = standSpecies.find(s => s.species === species);
        return found ? found.percentage : 0;
    };

    const handlePercentageChange = (species, val) => {
        const newValue = parseInt(val) || 0;
        let updated = [...standSpecies];
        const index = updated.findIndex(s => s.species === species);

        if (index >= 0) {
            updated[index].percentage = newValue;
        } else {
            updated.push({ species, percentage: newValue });
        }

        // Ensure total is 100% (optional, but good for UX)
        // For now, let's just let the user set them and show a warning
        setStandSpecies(updated.filter(s => s.percentage > 0));
    };

    const total = standSpecies.reduce((sum, s) => sum + s.percentage, 0);

    return (
        <Box sx={{ mt: 2, mb: 1 }}>
            <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                Species Distribution ({total}%)
                {total !== 100 && (
                    <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                        (Should be 100%)
                    </Typography>
                )}
            </Typography>
            <Grid container spacing={1}>
                {speciesOptions.map(species => (
                    <Grid item xs={4} key={species}>
                        <TextField
                            label={species === 'Bjork' ? 'Björk' : species}
                            type="number"
                            size="small"
                            fullWidth
                            value={getPercentage(species)}
                            onChange={(e) => handlePercentageChange(species, e.target.value)}
                            InputProps={{ inputProps: { min: 0, max: 100 } }}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SpeciesPicker;
